import * as React from 'react';
import { Segment } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { TagFilter } from '~/InfoCardsFilter/TagFilter';
export var InfoCardTypeFilter = function (_a) {
    var filter = _a.filter, filteredSource = _a.filteredSource, types = _a.types;
    var typeFilters = types.sort(function (a, b) { return a.infoCardType.title.localeCompare(b.infoCardType.title); });
    return (<Segment data-testid='type-filters'>
			{typeFilters.map(function (option) {
            var _a = option.sourceId.split(':'), value = _a[1];
            return (<TagFilter condition={{ type: InfoCardApi.TagType.type, value: option.infoCardType.value }} disabled={filteredSource !== null && filteredSource.value !== value} filter={filter} key={option.infoCardType.value}>
						{option.infoCardType.title}
					</TagFilter>);
        })}
		</Segment>);
};
